class LookupDataService {
  private readonly STORAGE_KEY = 'lookupData';

  getData() {
    try {
      const raw = localStorage.getItem(this.STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  saveData(data: any) {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
      window.dispatchEvent(new Event('lookup-data-changed'));
    } catch (error) {
      console.error('Failed to cache data:', error);
    }
  }

  async fetchDataOnLogin(baseUrl: string, token: string) {
    const response = await fetch(baseUrl + "appData/GetAllLookupData", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
    });

    if (!response.ok) {
      const body = await response.text();
      console.error(`GetAllLookupData failed (${response.status}):`, body);
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const result = await response.json();
    this.saveData(result);
    return result;
  }

  clearCache() {
    localStorage.removeItem(this.STORAGE_KEY);
  }
}

export default new LookupDataService();